/**
 * Up-to-two-letter initials from a display name — first letter of the
 * first and last words, uppercased. Returns undefined when the name has
 * no usable characters.
 */
export function getInitials(
  name: string | null | undefined,
): string | undefined {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts.at(-1)?.[0] ?? '') : '';
  return (first + last).toUpperCase() || undefined;
}
